module.exports = __webpack_public_path__ + "static/media/contracts.ecc982eb.svg";